export default __webpack_public_path__ + "static/media/bwVector.de1f1e5a.svg";